// 获取项目类别
export const getCategories = state => state.step.categories

// 获取计算后的价格和时间
export const getEvaluation = state => state.step.evaluation

// 获取修改后的估价数据
export const getSelectData = state => state.step.selectData

// 获取角色数据
export const getDomains = state => state.exam.domains
